export const U = (id, w = 1400) =>
    `https://images.unsplash.com/${id}?q=80&w=${w}&auto=format&fit=crop`;

export const IMAGES = {
    heroMain: U("photo-1600210491892-03d54c0aaf87", 1600),
    heroInset: U("photo-1693854774681-e24977fc66f5", 800),
};
